export default (app) => {
    return {
        namespaced: true,

        state: () => ({
            features: {},
            loaded: false,
        }),

        getters: {
            feature: (state) => (key) => {
                return state.features[key];
            },
        },

        mutations: {
            setFeatures(state, object) {
                Object.keys(object).forEach(key => {
                    state.features[key] = object[key];
                });

                state.loaded = true;
            },
        },

        actions: {
            async load({commit}) {
                const settings = app.config.globalProperties.$store.getters['settings/settings'];

                commit('setFeatures', settings);
            },
        },
    };
};
